import {Component, Input} from '@angular/core';
import {ContactPerson} from "../../interfaces/contact-person";

@Component({
  selector: 'brt-contact-persons',
  templateUrl: './contact-persons.component.html',
  styleUrls: ['./contact-persons.component.scss']
})
export class ContactPersonsComponent {

  contactPersons: ContactPerson[] = new Array(0);
  displayedContactPersons: ContactPerson[] = new Array(0);
  headline = "Ansprechperson";
  showAll = false;
  hiddenContactPersonsCount = 0;

  @Input("contact-persons") set setContactPersons(value: ContactPerson[]) {
    this.displayedContactPersons = new Array(0);
      this.contactPersons = value;
    if(this.contactPersons.length > 1) {
      this.headline = "Ansprechpersonen"
    } else {
      this.headline = "Ansprechperson"
    }

    if(this.contactPersons.length > 2) {
      this.displayedContactPersons.push(this.contactPersons[0]);
      this.displayedContactPersons.push(this.contactPersons[1]);
    } else {
      this.displayedContactPersons = this.contactPersons;
    }

    this.hiddenContactPersonsCount = this.contactPersons.length - this.displayedContactPersons.length;

  }

  toggleShowAllList() {
    this.showAll = !this.showAll;
    if(this.showAll) {
      this.displayedContactPersons = this.contactPersons;
    } else {
      this.displayedContactPersons = new Array(0);
      this.displayedContactPersons.push(this.contactPersons[0]);
      this.displayedContactPersons.push(this.contactPersons[1]);
    }

  }
}
